import { Roles, Subjects } from "settings/permissions";

export const REDIRECT_TO_ACTIVITY_OVERVIEW = "/performance/sql_activity_overview";
export const REDIRECT_TO_ACTIVITY_DETAILS = "/performance/what_happened";
export const REDIRECT_TO_BLOCKING_OVERVIEW = "/performance/blocking_overview";
export const REDIRECT_TO_DEADLOCKS_OVERVIEW = "/performance/deadlocks_overview";
export const REDIRECT_TO_BLOCKING_DETAILS = "/performance/blocking_details";
export const REDIRECT_TO_DEADLOCKS_DETAILS = "/performance/deadlocks_details";
export const REDIRECT_TO_JOB_DETAILS = "/performance/jobs_details";
export const REDIRECT_TO_QUERY_STAT = "/performance/query_statistics_overview";
export const REDIRECT_TO_QUERY_STAT_DETAILS = "/performance/query_statistics_details";
export const REDIRECT_TO_ACTIVITY_COMPARE = "/performance/sql_activity_compare";
export const REDIRECT_TO_INDEX_OVERVIEW = "/performance/index_overview";
export const REDIRECT_TO_INDEX_DETAILS = "/performance/index_details";
export const REDIRECT_TO_AVAILABILITY_GROUPS = "/performance/availability_groups_overview";
export const REDIRECT_TO_CONNECTIONS_DETAILS = "/performance/connections_details";

export const performancePages = {
  id: "Performance",
  label: "Performance",
  icon: "metricbeatApp", //"database",
  items: [
    {
      label: "What Happened?",
      path: "/performance/what_happened",
      requireClientSelection: true,
      permissions: {
        subject: Subjects.SQL_Activity_Dashboard,
        role: Roles.Read,
      },
    },
    {
      label: "Workload Activity",
      path: "/performance/sql_activity_overview",
      requireClientSelection: true,
      permissions: {
        subject: Subjects.SQL_Activity_Dashboard,
        role: Roles.Read,
      },
    },
    {
      label: "Workload Compare",
      path: "/performance/sql_activity_compare",
      requireClientSelection: true,
      permissions: {
        subject: Subjects.SQL_Activity_Dashboard,
        role: Roles.Read,
      },
    },
    {
      label: "Query Analysis",
      path: "/performance/query_statistics_overview",
      requireClientSelection: true,
      permissions: {
        subject: Subjects.Query_Statistics_Dashboard,
        role: Roles.Read,
      },
      topNavLinks: [
        {
          label: "Overview",
          path: "/performance/query_statistics_overview",
          requireClientSelection: true,
        },
        {
          label: "Details",
          path: "/performance/query_statistics_details",
          requireClientSelection: true,
        },
      ],
    },
    {
      label: "Index Analysis",
      path: "/performance/index_overview",
      requireClientSelection: true,
      permissions: {
        subject: Subjects.Index_Dashboards,
        role: Roles.Read,
      },
      topNavLinks: [
        {
          label: "Overview",
          path: "/performance/index_overview",
          requireClientSelection: true,
        },
        {
          label: "Details",
          path: "/performance/index_details",
          requireClientSelection: true,
        },
      ],
    },
    {
      label: "Blocking",
      path: "/performance/blocking_overview",
      requireClientSelection: true,
      permissions: {
        subject: Subjects.Blocking_Dashboard,
        role: Roles.Read,
      },
      topNavLinks: [
        {
          label: "Overview",
          path: "/performance/blocking_overview",
          requireClientSelection: true,
        },
        {
          label: "Details",
          path: "/performance/blocking_details",
          requireClientSelection: true,
        },
      ],
    },
    {
      label: "Deadlocks",
      path: "/performance/deadlocks_overview",
      requireClientSelection: true,
      permissions: {
        subject: Subjects.Deadlocks_Dashboard,
        role: Roles.Read,
      },
      topNavLinks: [
        {
          label: "Overview",
          path: "/performance/deadlocks_overview",
          requireClientSelection: true,
        },
        {
          label: "Details",
          path: "/performance/deadlocks_details",
          requireClientSelection: true,
        },
      ],
    },
    {
      label: "Agent Jobs",
      path: "/performance/jobs_overview",
      requireClientSelection: true,
      permissions: {
        subject: Subjects.Job_Dashboards,
        role: Roles.Read,
      },
      topNavLinks: [
        {
          label: "Overview",
          path: "/performance/jobs_overview",
          requireClientSelection: true,
        },
        {
          label: "Details",
          path: "/performance/jobs_details",
          requireClientSelection: true,
        },
      ],
    },
    {
      label: "Database Connections",
      path: "/performance/connections_overview",
      requireClientSelection: true,
      permissions: {
        subject: Subjects.Client_Connections_Dashboard,
        role: Roles.Read,
      },
      topNavLinks: [
        {
          label: "Overview",
          path: "/performance/connections_overview",
          requireClientSelection: true,
        },
        {
          label: "Details",
          path: "/performance/connections_details",
          requireClientSelection: true,
        },
      ],
    },
    {
      label: "Availability Groups",
      path: "/performance/availability_groups_overview",
      requireClientSelection: true,
      permissions: {
        subject: Subjects.Availability_Groups_Dashboard,
        role: Roles.Read,
      },
    },
  ],
};
